import React from 'react';

const PropsData = React.createContext();

const Navigation = React.createContext();

const VisaValda = React.createContext(false);

const UserData = React.createContext();

export {PropsData, Navigation, VisaValda, UserData};